"use strict";

import angular from "angular";

import template from "./help-center.component.html";
import "./themes/help-center.component.scss";

import _ from "lodash";

import { User } from "../../../gateway/User/User";
import { Events } from "../../../presentation/services/Events/Events";
import { AccountingNewGateway } from "../../../gateway/AccountingNewGateway/AccountingNewGateway";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import {
    accountingUsers,
    accoutingTrialUsers,
    nucontersUsers
} from "../../../utils/users-roles/users-roles";

import { Features } from "./features";
import { Helpers } from "./helpers";
import helpDialogTemplate from "../../dialogs/help-dialog/help-dialog.html";

class HelpCenterComponent {
    AccountingNewGateway = new AccountingNewGateway();
    news = {};
    newsTabIndex = 0;
    canSeeAccountingIds = false;
    currentUser = new UserDataAdapter().user();

    constructor(
        CentralSidenavService,
        DSNDialogService,
        $state,
        $stateParams,
        $rootScope,
        AccountingNewsService,
        ChatAtendimentoService
    ) {
        this.User = new User();
        this.Events = new Events();
        this.$stateParams = $stateParams;
        this.CentralSidenavService = CentralSidenavService;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.AccountingNewsService = AccountingNewsService;
        this.ChatAtendimentoService = ChatAtendimentoService;
        this.Features = Features;
        this.helpers = Helpers;
    }

    $onInit() {
        this.getNews();
        this.$rootScope.$on("FINISH_AUTO_ASSOCIATED_ACCOUNTS", () => {
            this.getNews();
        });
    }

    $onDestroy() {}

    $onChanges(changes) {
        if (changes.user && _.get(changes, "user.currentValue._id")) {
            this.CentralSidenavService.setFeaturesCount();
            this.canSeeAccountingIds = this.User.checkPermission({
                roles: [
                    ...accountingUsers,
                    ...accoutingTrialUsers,
                    ...nucontersUsers
                ],
                granted: _.get(this.user, "roles")
            });
        }
    }

    getAccountingSuperLogicaId() {
        return this.accounting?.superLogica?._id;
    }

    getAccountingHubspotId() {
        return this.accounting?.hubspot?._id;
    }
    chatDisponivel() {
        return this.ChatAtendimentoService.isDisponivel();
    }

    openChat() {
        this.CentralSidenavService.close();
        this.ChatAtendimentoService.open();
    }

    onOpenHelpDialog = () => {
        this.CentralSidenavService.close();
        const body = angular.element(document.querySelector("body"));
        body.addClass("overwrite-chat-rules");
        this.DSNDialogService.custom({
            controller: "HelpDialogCtrl as $ctrl",
            locals: {
                templateHtml: helpDialogTemplate,
                width: "512px",
                title: "Enviar feedback"
            },
            after: {
                hide: () => {
                    body.removeClass("overwrite-chat-rules");
                },
                cancel: () => {
                    this.ChatAtendimentoService.toMaintain();
                }
            }
        });
        this.Events.send("Menu.Feedback");
    };

    parseModuleEvent(module) {
        return module.replace(/\s/g, "");
    }
    async onSelectTabNews() {
        this.CentralSidenavService.setCount(0);
    }

    async getNews() {
        if (!this.accountingId) return;

        const response = await this.AccountingNewGateway.getNews({
            userId: this.currentUser._id,
            accountingId: this.accountingId
        });

        this.news = response;
        this.AccountingNewsService.set(response);
        this.CentralSidenavService.setHasUnreadNotifications(
            this.hasNotification()
        );
    }

    hasNotification() {
        if (!this.news?.length) return false;
        return this.news.some((item) => !item.props.wasRead);
    }

    getUnreadNotificationsCount() {
        if (!this.news?.length) return 0;
        return this.news.filter((item) => !item.props.wasRead).length;
    }

    onRedirect(link, item) {
        if (!item.props.wasRead) {
            item.props.wasRead = true;
            this.onUpdateRead(item._id);
        }

        this.CentralSidenavService.setHasUnreadNotifications(
            this.hasNotification()
        );

        if (item.props.notificationCode === 22) {
            const href = this.$state.href(
                "nucont.accounting.company.dashboards.view",
                {
                    id: item.props.companyId,
                    accountingId: this.accountingId,
                    source: "contabil"
                }
            );
            window.open(href, "_blank");
            this.CentralSidenavService.close();
            return;
        }

        if (item.props.options?.link)
            window.open(item.props.options.link, "_blank");
        else if (link.uiSref?.length) this.$state.go(...link.uiSref);

        this.CentralSidenavService.close();
    }

    onUpdateRead(id) {
        this.AccountingNewGateway.updateRead({ ids: [id] });
    }

    goToCentral() {
        this.Events.send("menu.centralconhecimento");

        window.open("https://atendimento.nucont.com/hc/central-de-conhecimento/pt_BR", "_blank");
    }

    openNucontMaterials() {
        this.Events.send("menu.workshops");
        window.open(`https://pages.nucont.com/workshops`, "_blank");
    }
    onCustomAction(feature) {
        feature.customAction({ $state: this.$state });
    }
}

HelpCenterComponent.$inject = [
    "CentralSidenavService",
    "DSNDialogService",
    "$state",
    "$stateParams",
    "$rootScope",
    "AccountingNewsService",
    "ChatAtendimentoService"
];

const name = "helpCenterComponent";
const def = {
    bindings: {
        user: "<",
        accountingId: "<",
        accounting: "<"
    },
    controller: HelpCenterComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
